import React from 'react';
import { Chip } from '@mui/material';

const StatusCell = ({ item, config, onToggleErrorPanel }) => {
  const statusConfig = config.statusConfig.validationStatuses[item.validationStatus];
  const importStatusConfig = config.statusConfig.importStatuses?.[item.importStatus];
  const errors = item.validationErrors || [];
  const hasErrors = (item.validationStatus === 'invalid' || item.importStatus === 'failed') && errors.length > 0;

  const handleStatusClick = (event) => {
    event.stopPropagation();
    if (hasErrors && onToggleErrorPanel) {
      onToggleErrorPanel(item.id);
    }
  };

  // If there's an import status, show that instead of validation status
  if (item.importStatus && importStatusConfig) {
    return (
      <Chip
        label={importStatusConfig.label}
        size="small"
        variant="outlined"
        onClick={hasErrors && onToggleErrorPanel ? handleStatusClick : undefined}
        sx={{
          borderColor: importStatusConfig.color,
          color: importStatusConfig.color,
          backgroundColor: importStatusConfig.backgroundColor,
          cursor: hasErrors && onToggleErrorPanel ? 'pointer' : 'default',
          '&:hover': hasErrors && onToggleErrorPanel ? {
            backgroundColor: importStatusConfig.backgroundColor,
            opacity: 0.8
          } : {}
        }}
        title={hasErrors ? errors[0]?.message : ''}
      />
    );
  }

  return (
    <Chip
      label={statusConfig?.label || item.validationStatus}
      size="small"
      variant="outlined"
      onClick={hasErrors && onToggleErrorPanel ? handleStatusClick : undefined}
      sx={{
        borderColor: statusConfig?.color || '#6B7280',
        color: statusConfig?.color || '#6B7280',
        cursor: hasErrors && onToggleErrorPanel ? 'pointer' : 'default',
        '&:hover': hasErrors && onToggleErrorPanel ? {
          backgroundColor: '#FEE2E2',
          borderColor: '#DC2626'
        } : {}
      }}
      title={hasErrors ? errors[0]?.message : ''}
    />
  );
};

export default StatusCell;